const _ = require('lodash');

function chunkResultSet() {
    return _.memoize(_.chunk);
}

module.exports = chunkResultSet;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/list-review/chunk-filter.js
 **/